'use client';

import { PasswordInput } from '@apex-titan/ui';
import { type ComponentProps } from 'react';
import {
  useController,
  type FieldValues,
  type UseControllerProps,
} from 'react-hook-form';

type FormPasswordInputProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<
    ComponentProps<typeof PasswordInput>,
    'value' | 'onChange' | 'name' | 'defaultValue'
  >;

export function FormPasswordInput<T extends FieldValues>({
  name,
  control,
  rules,
  defaultValue,
  shouldUnregister,
  ...inputProps
}: FormPasswordInputProps<T>) {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
    defaultValue,
    shouldUnregister,
  });
  return (
    <PasswordInput
      {...inputProps}
      {...field}
      value={field.value ?? ''}
      errorMessage={fieldState.error?.message}
    />
  );
}
